var map = {
	"./arrrmages.png": 8622,
	"./blocksurfers.png": 8060,
	"./blocksurfers.svg": 7310,
	"./bytebenders.png": 1001,
	"./chainchamps.png": 3390,
	"./crypticbanter.png": 3164,
	"./cryptowizards-full.png": 9988,
	"./cryptowizards.png": 2505,
	"./darkknights copy.png": 5573,
	"./darkknights.png": 2295,
	"./darkknights2.png": 3752,
	"./datamavericks.png": 6447,
	"./datascavengers.png": 1032,
	"./fswizards.png": 3826,
	"./humbleherbs.png": 4613,
	"./pineanalytics.png": 1801,
	"./quizzicalquokkas.png": 3193,
	"./seleçãosquad.png": 8573,
	"./team2.png": 9448,
	"./team3.png": 2484,
	"./team4.png": 8103,
	"./team8.png": 3552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2691;